<template>
  <div class="responsiveMessages">
    <div class="column has-text-centered">
      <div class="title is-3 is-margin-bottom">
        <div v-if="displayMobileError" class="responsiveMessages-mobile">Oups !</div>
        <div class="responsiveMessages-tablette">Oups !</div>
        <div class="responsiveMessages-desktop">Oups !</div>
      </div>

      <!-- <img src="static/responsive-house.gif" width="100%" :alt="$configs.COMPANY" class="is-margin-bottom"> -->
      <video width="100%" muted autoplay loop playsinline class="is-margin-bottom" id="video">
        <source src="static/responsive-house.mp4" type="video/mp4">
      </video>

      <div class="title is-3 has-text-weight-bold is-margin-bottom">
        <div v-if="displayMobileError" class="responsiveMessages-mobile">Résolution d’affichage insuffisante.</div>
        <div class="responsiveMessages-tablette">Résolution d’affichage insuffisante.</div>
        <div class="responsiveMessages-desktop">Résolution d’affichage insuffisante.</div>
      </div>

      <div class="is-size-5 has-text-weight-light is-margin-bottom">
        <div v-if="displayMobileError" class="responsiveMessages-mobile">Veuillez-vous diriger vers la version mobile du
          site.
        </div>
        <div class="responsiveMessages-tablette">La résolution d’affichage n’est pas suffisante pour afficher
          correctement les informations. Veuillez basculer votre appareil en vue paysage ou vous diriger vers la version
          mobile du site.
        </div>
        <div class="responsiveMessages-desktop">La résolution d’affichage n’est pas suffisante pour afficher
          correctement les informations. Veuillez agrandir la fenêtre de votre navigateur.
        </div>
      </div>

      <div class="">
        <div class="responsiveMessages-mobile">
          <a :href="mobileHost" class="button is-primary">Rejoindre la version mobile</a>
        </div>
        <div class="responsiveMessages-tablette">
          <a :href="mobileHost" class="button is-primary">Rejoindre la version mobile</a>
        </div>
        <div class="responsiveMessages-desktop"></div>
      </div>
    </div>
  </div>
  <!-- <div class="is-overlay is-hidden-desktop has-bg-primary" id="responsive-message">
    <div class="column is-border has-bg-white has-text-centered is-block-mobile">
      <img :src="$configs.LOGO_LOGIN" width="100%" :alt="$configs.COMPANY" class="is-margin-bottom">
      <p class="is-size-2 has-text-weight-light">
        Bonjour, veuillez-vous diriger vers la version mobile du site :
        <a :href="mobileHost">{{$configs.MOBILE_WEBSITE}}</a>
      </p>
    </div>
    <div class="column is-border has-bg-white has-text-centered is-block-tablet-only">
      <img :src="$configs.LOGO_LOGIN" width="100%" :alt="$configs.COMPANY" class="is-margin-bottom">
      <p class="is-size-2 has-text-weight-light">La résolution d’affichage n’est pas suffisante pour afficher correctement les informations.<br>Veuillez basculer votre appareil </p>
    </div>
  </div> -->
</template>

<script>
  import { mapState } from 'vuex'
  import { intersection } from 'lodash'

  export default {
    name: 'MobileResponsiveError',
    data () {
      return {
        displayMobileError: true
      }
    },
    computed: {
      ...mapState(['configs']),
      mobileHost () {
        if (this.configs) {
          return this.configs.MOBILE_HOST
        }
        return null
      }
    },
    watch: {
      mobileHost (value) {
        if (value) {
          this.redirect()
        }
      }
    },
    methods: {
      redirect () {
        let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        if (intersection(navigator.userAgent.match(/([A-Z])\w+/ig), ['Mobile', 'Android', 'iPhone']).length && w < 768) {
          this.displayMobileError = false
          const link = document.createElement('a')
          link.href = this.mobileHost
          document.body.appendChild(link)
          link.click()
        }
      }
    },
    created () {
      if (this.mobileHost) {
        this.redirect()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/MobileResponsiveError.vue